import {combineReducers} from '@reduxjs/toolkit';

import landUnitTooltips from 'App/features/map2DEntities/landUnitTooltips/landUnitTooltipsSlice';

import focusedUnits from './focusedUnits/focusedUnitsSlice';
import legend from './legend/legendSlice';
import prescriptionsEditor from './prescriptionsEditor/prescriptionsEditorSlice';
import selectedParcels from './selectedParcels/selectedParcelsSlice';
import viewModes2D from './viewModes/viewModes2DSlice';

const map2DEntities = combineReducers({
  legend,
  prescriptionsEditor,
  viewModes2D,
  selectedParcels,
  focusedUnits,
  landUnitTooltips,
});

export default map2DEntities;
